"use client";

/**
 * RetentionBadge — #526 (ADR-INFRA-001 D-I2): aviso discreto de retenção do
 * vídeo bruto (crops NUNCA expiram, D-V2 — só o `.mp4` bruto é apagado pelo
 * job de limpeza em `app/video/retention.py`).
 *
 * Presentational-only — toda a derivação (dias restantes, cor, texto) vive
 * em `@/lib/retention-helpers` (pure, testado com asserções reais), mesmo
 * padrão de `FilaPlacar`/`fila-helpers`.
 *
 * Retorna `null` quando não há prazo aplicável (`bruto_expira_em` null) —
 * nunca renderiza um badge vazio/fabricado. Usado tanto na lista (`/`) quanto
 * no hub do levantamento (`/[lev_id]`).
 */

import { computeRetentionInfo } from "@/lib/retention-helpers";

interface RetentionBadgeProps {
  brutoExpiraEm: string | null | undefined;
}

export function RetentionBadge({ brutoExpiraEm }: RetentionBadgeProps) {
  const info = computeRetentionInfo(brutoExpiraEm);
  if (!info) return null;

  return (
    <span
      className={`rounded px-2 py-0.5 text-[10px] font-semibold ${info.colorCls}`}
      data-testid="retention-badge"
    >
      {info.label}
    </span>
  );
}
